var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"custom_success_page_popup_wrap"},[_c('div',{staticClass:"success_icon_wrap"},[_c('svg',{staticClass:"icon",attrs:{"aria-hidden":"true"}},[_c('use',{attrs:{"xlink:href":"#icon-chenggong"}})])]),_c('div',{staticClass:"success_text"},[_vm._v("您已提交成功")])])
}
var staticRenderFns = []

export { render, staticRenderFns }